var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"width":"100%","height":"100%","controls":"","autoplay":""}},[_c('source',{attrs:{"src":_vm.video.path,"type":"video/mp4"}}),_vm._v(" 您的浏览器不支持Video标签。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }